import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const EmailCampaigns = lazy(() => import("@/pages/admin/email/campaigns/EmailCampaigns/EmailCampaigns"));
const AddEmailCampaign = lazy(() => import("@/pages/admin/email/campaigns/AddEmailCampaign/AddEmailCampaign"));
const EditEmailCampaign = lazy(() => import("@/pages/admin/email/campaigns/EditEmailCampaign/EditEmailCampaign"));
const EmailCampaignStats = lazy(() => import("@/pages/admin/email/campaigns/EmailCampaignStats/EmailCampaignStats"));

const UnsubscribedClients = lazy(() => import("@/pages/admin/email/unsubscribed-clients/UnsubscribedClients"));

const VerifiedEmails = lazy(() => import("@/pages/admin/email/verified-emails/VerifiedEmails"));
const CustomBrandedDomains = lazy(
  () => import("@/pages/admin/email/custom-branded-domains/CustomBrandedDomains"),
);
const EmailCampaignSettings = lazy(() => import("@/pages/admin/email/settings/EmailCampaignSettings"));

const PrintMarketingReport = lazy(
  () => import("@/pages/admin/email/marketing-reports/PrintMarketingReport/PrintMarketingReport"),
);
const PrintMailerReminder = lazy(
  () => import("@/pages/admin/email/marketing-reports/PrintMailerReminder/PrintMailerReminder"),
);

const Error404 = lazy(() => import("@/pages/Error404"));

const emailsRoutes: RouteObject[] = [
  {
    index: true,
    element: <Error404 />,
  },
  {
    path: "campaigns",
    children: [
      {
        index: true,
        element: <EmailCampaigns />,
      },
      {
        path: "new",
        element: <AddEmailCampaign />,
      },
      {
        path: ":id",
        element: <EditEmailCampaign />,
      },
      {
        path: ":id/stats",
        element: <EmailCampaignStats />,
      },
    ],
  },

  {
    path: "unsubscribed-clients",
    children: [
      {
        index: true,
        element: <UnsubscribedClients />,
      },
    ],
  },
  {
    path: "verified-emails",
    element: <VerifiedEmails />,
  },
  {
    path: "custom-branded-domains",
    element: <CustomBrandedDomains />,
  },
  {
    path: "settings",
    children: [
      {
        index: true,
        element: <EmailCampaignSettings />,
      },
    ],
  },
  {
    path: "print-marketing-report",
    element: <PrintMarketingReport />,
  },
  {
    path: "print-mailer-reminder",
    element: <PrintMailerReminder />,
  },
];

export default emailsRoutes;
